const wrapHour = (hour) => ((hour % 24) + 24) % 24;

const lerp = (start, end, t) => start + (end - start) * t;
const smoothstep = (t) => t * t * (3 - 2 * t);

const hexToRgb = (hex) => ({
  r: (hex >> 16) & 255,
  g: (hex >> 8) & 255,
  b: hex & 255,
});

const rgbToHex = ({ r, g, b }) =>
  `#${Math.round(r).toString(16).padStart(2, '0')}${Math.round(g).toString(16).padStart(2, '0')}${Math.round(b).toString(16).padStart(2, '0')}`;

const mixHexColors = (fromHex, toHex, mix) => {
  const from = hexToRgb(fromHex);
  const to = hexToRgb(toHex);
  return rgbToHex({
    r: lerp(from.r, to.r, mix),
    g: lerp(from.g, to.g, mix),
    b: lerp(from.b, to.b, mix),
  });
};

const interpolateFromKeyframes = (hour, keyframes, field) => {
  const wrappedHour = wrapHour(hour);

  for (let i = 0; i < keyframes.length - 1; i += 1) {
    const start = keyframes[i];
    const end = keyframes[i + 1];

    if (wrappedHour >= start.hour && wrappedHour <= end.hour) {
      const rawMix = (wrappedHour - start.hour) / (end.hour - start.hour);
      const mix = smoothstep(rawMix);
      return mixHexColors(start[field], end[field], mix);
    }
  }

  return rgbToHex(hexToRgb(keyframes[0][field]));
};

const skyGradientKeyframes = [
  { hour: 0, top: 0x0b1630, bottom: 0x1d2747 },
  { hour: 5, top: 0x1f2f5f, bottom: 0x3b4a74 },
  { hour: 7, top: 0xf7a26f, bottom: 0xfcd7a0 },
  { hour: 10, top: 0x9dd0ff, bottom: 0xdff1ff },
  { hour: 13, top: 0x8ec5ff, bottom: 0xe8f6ff },
  { hour: 16, top: 0x9ec7f0, bottom: 0xf8dfba },
  { hour: 19, top: 0xd37b5b, bottom: 0x40285b },
  { hour: 21, top: 0x1b2550, bottom: 0x141c3a },
  { hour: 24, top: 0x0b1630, bottom: 0x1d2747 },
];

const lightColorKeyframes = [
  { hour: 0, color: 0x0f1f40 },
  { hour: 5, color: 0x243b66 },
  { hour: 7, color: 0xffb272 },
  { hour: 10, color: 0xfff2d9 },
  { hour: 13, color: 0xffffff },
  { hour: 16, color: 0xfff0d0 },
  { hour: 19, color: 0xffa25a },
  { hour: 21, color: 0x4a5a87 },
  { hour: 24, color: 0x0f1f40 },
];

export const getSkyGradientForHour = (hour) => {
  const top = interpolateFromKeyframes(hour, skyGradientKeyframes, 'top');
  const bottom = interpolateFromKeyframes(hour, skyGradientKeyframes, 'bottom');
  return `linear-gradient(to bottom, ${top}, ${bottom})`;
};

export const getLightColorForHour = (hour) => {
  const colorHex = interpolateFromKeyframes(hour, lightColorKeyframes, 'color');
  return Number.parseInt(colorHex.slice(1), 16);
};
